import popupStyles from "./paymentActionConfirmModal.module.css";
import { IPopupWithoutProps } from "../../../types/types";
import venchyImg from "../../../images/questionnaire_doctor.png";
import { tWithKeyAttr as t } from "../../../i18nHelper";
import { PaymentOperation } from "../../../services/types/utils.types";
import { useState } from "react";

interface PaymentActionConfirmModalProps extends IPopupWithoutProps {
  onConfirm: (customMessage?: string) => void;
  operation: PaymentOperation;
  selectedCount: number;
  isProcessing?: boolean;
}

function PaymentActionConfirmModal({
  onClose,
  onConfirm,
  operation,
  selectedCount,
  isProcessing = false,
}: PaymentActionConfirmModalProps) {
  const [customMessage, setCustomMessage] = useState<string>("");
  const getOperationTitle = () => {
    switch (operation) {
      case 'CreateToken':
        return t('PAYMENT_TOKEN_CREATION_LINK');
      case 'ChargeOnly':
        return t('CHARGE_CUSTOMER_LINK');
      case 'ChargeAndToken':
        return t('CREATE_TOKEN_AND_CHARGE_LINK');
      default:
        return '';
    }
  };

  const getConfirmationText = () => {
    switch (operation) {
      case 'CreateToken':
        return t('CONFIRM_PAYMENT_TOKEN_CREATION', { count: selectedCount });
      case 'ChargeOnly':
        return t('CONFIRM_CHARGE_CUSTOMER', { count: selectedCount });
      case 'ChargeAndToken':
        return t('CONFIRM_CREATE_TOKEN_AND_CHARGE', { count: selectedCount });
      default:
        return '';
    }
  };

  return (
    <article className={popupStyles.popup} data-testid="payment-action-confirm-popup">
      <img className={popupStyles.popup__img} src={venchyImg} alt={t('VENCHI')} />
      <h2 className={popupStyles.popup__title}>{getOperationTitle()}</h2>
      <p className={popupStyles.popup__text}>{getConfirmationText()}</p>
      
      <div className={popupStyles.popup__fields}>
        <div className={popupStyles.popup__field}>
          <label className={popupStyles.popup__fieldLabel}>
            {t('CUSTOM_MESSAGE_LABEL')}
          </label>
          <textarea
            className={popupStyles.popup__fieldInput}
            value={customMessage}
            onChange={(e) => setCustomMessage(e.target.value)}
            disabled={isProcessing}
            maxLength={500}
            placeholder={t('CUSTOM_MESSAGE_PLACEHOLDER')}
            rows={3}
            style={{ resize: 'vertical', minHeight: '60px' }}
            data-testid="custom-message-input"
          />
        </div>
      </div>
      
      <div className={popupStyles.popup__buttons}>
        <button
          className={`button ${popupStyles.popup__confirmBtn} hover`}
          data-testid="confirm-payment-action-button"
          onClick={() => {
            onConfirm(customMessage || undefined);
          }}
          disabled={isProcessing}
        >
          {isProcessing ? t('PROCESSING') : t('CONFIRM')}
        </button>
        <button
          className={`button ${popupStyles.popup__cancelBtn} hover`}
          data-testid="cancel-payment-action-button"
          onClick={onClose}
          disabled={isProcessing}
        >
          {t('CANCEL')}
        </button>
      </div>
    </article>
  );
}

export default PaymentActionConfirmModal;
